import Grid from '@mui/material/Grid';
import { Skeleton } from '@mui/material';
import styled from 'styled-components';

const LoadingText = () => (
  <Skeleton
    variant="rectangular"
    width={100}
    height={25}
    sx={{ borderRadius: '98px' }}
  />
);

export const ReportTab = ({
  activeTab,
  reviewClicked,
  logbookClicked,
  showSkeleton
}) => {
  return (
    <StyledReportTab>
      <Grid container mt={{ xs: '50px', md: '80px' }}>
        <Grid
          className={`tabContainerStyle ${
            activeTab === 1 && ' activeReportTabStyle'
          }`}
          onClick={reviewClicked}
          item
          xs={6}
        >
          {showSkeleton ? <LoadingText /> : 'REPORT'}
        </Grid>
        <Grid
          className={`tabContainerStyle ${
            activeTab === 2 && ' activeLogbookTabStyle'
          }`}
          onClick={logbookClicked}
          item
          xs={6}
        >
          {showSkeleton ? <LoadingText /> : 'LOG BOOK'}
        </Grid>
      </Grid>
    </StyledReportTab>
  );
};

const StyledReportTab = styled.div`
  .tabContainerStyle {
    font-size: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'dana-bold';
    height: 60px;
    padding-top: 12px;
    color: #707070;
  }
  .activeReportTabStyle {
    background-color: #ffffff;
    border-radius: 16px 0 0;
    box-shadow: 0 -5px 5px 0 rgba(0, 0, 0, 0.1);
    color: #753cbe;
  }
  .activeLogbookTabStyle {
    background-color: #ffffff;
    border-radius: 0 16px 0 0;
    box-shadow: 0 -5px 5px 0 rgba(0, 0, 0, 0.1);
    color: #753cbe;
  }
  @media screen and (min-width: 1024px) {
    .tabContainerStyle {
      font-size: 28px;
      height: 70px;
      padding-top: 15px;
    }
    .activeReportTabStyle,
    .activeLogbookTabStyle {
      border-radius: 16px 16px 0 0;
    }
  }
`;
